var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { ImageGridWrapper, ImageBox, ImageRow, Image } from "./ImageGrid.styled";

var ImageGrid = function ImageGrid(_a) {
  var anchor = _a.anchor,
      _b = _a.md,
      md = _b === void 0 ? 6 : _b,
      _c = _a.lg,
      lg = _c === void 0 ? 3 : _c,
      disclaimer = _a.disclaimer,
      images = _a.images,
      props = __rest(_a, ["anchor", "md", "lg", "disclaimer", "images"]);

  return React.createElement(ImageGridWrapper, __assign({
    id: anchor
  }, props), React.createElement(ImageRow, null, images.map(function (image, index) {
    return React.createElement(ImageBox, {
      key: image.url + "_" + index,
      xs: 12,
      md: md,
      lg: lg
    }, React.createElement(Image, {
      as: image.linkUrl ? "a" : "span",
      href: image.linkUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        backgroundImage: "url('" + image.url + "')"
      }
    }), image.disclaimer && React.createElement("p", null, image.disclaimer));
  })), !!disclaimer && React.createElement("p", {
    className: "image-grid__disclaimer"
  }, disclaimer));
};

export default ImageGrid;